export const AnalyticCodes = {
  YANDEXMETRICA: process.env.REACT_APP_YANDEXMETRICA,
  GA: process.env.REACT_APP_GA,
  PIXEL: process.env.REACT_APP_PIXEL,
  GTM: process.env.REACT_APP_GTM,
};
